import { useEffect, useRef } from "react";

export interface EventLogProps {
  lines: string[];
  focusIndex: number;
}

export function EventLog({ lines, focusIndex }: EventLogProps) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current?.querySelector<HTMLDivElement>(
      `[data-line-index="${focusIndex}"]`,
    );
    el?.scrollIntoView({ block: "center", behavior: "auto" });
  }, [focusIndex, lines.length]);

  return (
    <div ref={ref} className="event-log">
      {lines.map((l, i) => (
        <div
          key={i}
          data-line-index={i}
          className={
            i === focusIndex ? "event-log__line event-log__line--focus" : "event-log__line"
          }
        >
          {l}
        </div>
      ))}
    </div>
  );
}
